import { Type } from 'class-transformer';
import { isNullOrUndefined } from 'util';

import { ChatMessage, ChatMessages } from './chat-message';

export type ChatDiscussions = ChatDiscussion[];

export class ChatDiscussion {

  @Type(() => ChatMessage)
  messages: ChatMessages = [];
  maintenanceRequestId: number;

  
  get isRead(): boolean {
    if (!isNullOrUndefined(this.messages) && this.messages.length > 0) {
      // If an unread message exists, return true. Else, return false.
      const unreadMessage = this.messages.find(msg => msg.read === 0);
      return isNullOrUndefined(unreadMessage);
    }

    // Return true if there are no messages
    return true;
  }

  public markAsRead(): void {
    if (!isNullOrUndefined(this.messages) && this.messages.length > 0) { 
      this.messages.forEach(message => message.read = 1);
    }
  }

  constructor(init?: Partial<ChatDiscussion>) {
    Object.assign(this, init);
  }
}
